export const styles = {
  blockingDisclaimer: { margin: '16px 0' },
  checkboxWrapper: { display: 'flex' },
  checkboxLabel: { marginLeft: 16 },
}
